
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";

@Component
export default class Auth extends Vue {
  @Getter("auth/codeVerifier") readonly codeVerifier!: string;
  @Mutation("auth/setAuthorizationCode") setAuthorizationCode!: (
    code: string
  ) => void;

  @Action("auth/requestToken") requestToken!: () => Promise<string>;
  @Action("unlock") unlock!: () => Promise<void>;

  render() {
    return null;
  }

  async created() {
    const code = this.$route.query.code;

    if (!code) {
      this.redirectToForbidden();
    }

    this.setAuthorizationCode(code as string);

    try {
      await this.requestToken();
      const profileParam = this.getCookie("adcontrolprofile");
      this.$router.push({
        name: "Dashboard",
        query: profileParam ? { profile: profileParam } : undefined,
      });
    } catch (_error) {
      this.redirectToForbidden();
    }
  }

  redirectToForbidden() {
    this.$router.push({ name: "Forbidden" });
  }

  getCookie(name: string): string | undefined {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift();
  }
}
